export interface UnionAirportListRecord {
    year: number;
    fileName: string;
    id: number;
}